import React from 'react';
import { WebinarOptIn } from './pages/WebinarOptIn';
export function App() {
  return <WebinarOptIn data-id="element-0" />;
}